export default {"src":"/_next/static/media/in_regular.26451560.svg","height":24,"width":24};